/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { jsx } from '@emotion/react'
import { Fragment, type FunctionComponent } from 'react'

import { EuiButton, EuiCallOut, EuiSpacer } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

type Props = {
  isLoading: boolean
  refetch: () => void
}

const CloudResourceLoadingError: FunctionComponent<Props> = ({ isLoading, refetch }) => (
  <EuiCallOut
    color='danger'
    data-test-id='billing.notifications.budgets.budget-settings.scope.cloud-resource.error'
    iconType='warning'
    title={
      <FormattedMessage
        id='billing.notifications.budgets.budget-settings.scope.cloud-resource.error.title'
        defaultMessage='We could not load your cloud resources'
      />
    }
  >
    <Fragment>
      <FormattedMessage
        id='billing.notifications.budgets.budget-settings.scope.cloud-resource.error.message'
        defaultMessage='There was an error loading the cloud resources. Wait 1 minute and try again. If this keeps happening, contact your administrator.'
      />

      <EuiSpacer size='m' />

      <EuiButton color='danger' onClick={() => refetch()} iconType='refresh' disabled={isLoading}>
        <FormattedMessage
          id='billing.notifications.budgets.budget-settings.scope.cloud-resource.error.button.try-again'
          defaultMessage='Try again'
        />
      </EuiButton>
    </Fragment>
  </EuiCallOut>
)

export default CloudResourceLoadingError
